<template>
  <GenericInfo api-endpoint="data" :type="type" @add="addsave" @save="addsave">
    <template v-slot:title>
      <h1 v-if="type === 2">{{ $t('informationModuleContent') }}</h1>
      <h1 v-else-if="type === 1">{{ $t('informationModuleEdit') }}</h1>
      <h1 v-else>{{ $t('addInformationModule') }}</h1>
    </template>
    <template v-slot:info>
      <div class="input-group-add">
        <label for="nickname" class="label-add">{{ $t('name') }}:</label>
        <input
          type="text"
          id="name"
          name="name"
          placeholder="name"
          class="input-add"
          v-model="inputNameValue"
          @input="validateNameValue"
          :disabled="type === 2"
        />
      </div>
      <p v-if="errorNameMessage" class="err-msg">{{ errorNameMessage }}</p>
      <div class="input-group-add">
        <label for="format" class="label-add">{{ $t('format') }}:</label>
        <DropdownSelect
          :id="'format'"
          :options="format"
          :value="formatId"
          :disabled="type === 2"
          v-model="formatId"
        />
      </div>
      <div class="input-group-add">
        <label for="topic" class="label-add">{{ $t('topic') }}:</label>
        <input
          type="text"
          id="topic"
          name="topic"
          placeholder="Topic"
          class="input-add"
          v-model="inputTopicValue"
          @input="validateTopicValue"
          :disabled="type === 2"
        />
      </div>
      <p v-if="errorTopicMessage" class="err-msg">{{ errorTopicMessage }}</p>
      <div class="input-group-add">
        <label for="unit" class="label-add">{{ $t('unit') }}:</label>
        <input
          type="text"
          id="unit"
          name="unit"
          placeholder="Unit"
          class="input-add"
          v-model="inputUnitValue"
          @input="validateUnitValue"
          :disabled="type === 2"
        />
      </div>
      <p v-if="errorUnitMessage" class="err-msg">{{ errorUnitMessage }}</p>
    </template>
  </GenericInfo>
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import Swal from 'sweetalert2';
import {
  validateCString, validateNumber, validateUnitString, validateMqttTopic,
} from '../utils/stringValid';
import {
  fetchData, insertData, updateData, fetchList,
} from '../utils/api';
import DropdownSelect from '../DropdownSelect.vue';
import GenericInfo from '../generic/GenericInfo.vue';

export default {
  components: {
    GenericInfo,
    DropdownSelect,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const page = ref('data');
    const btnLabel = ref(t('add'));
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const inputNameValue = ref('');
    const inputUnitValue = ref('');
    const inputTopicValue = ref('');
    const route = useRoute();
    const format = ref([]);
    const formatId = ref(1);
    fetchList(t, `${apiBaseUrl}/list/data_format`).then((response3) => {
      format.value = response3.data.result.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    });
    if (props.type !== 0) {
      onMounted(async () => {
        id.value = route.params.id;
        fetchData(t, `${apiBaseUrl}/info/${page.value}`, id.value).then((response) => {
          if (response.data) {
            inputNameValue.value = response.data.result.name;
            inputTopicValue.value = response.data.result.topic;
            inputUnitValue.value = response.data.result.unit;
            formatId.value = response.data.result.format;
          }
        });
      });
    }
    return {
      t,
      page,
      btnLabel,
      apiBaseUrl,
      id,
      inputNameValue,
      inputUnitValue,
      inputTopicValue,
      format,
      formatId,
    };
  },
  data() {
    return {
      errorNameMessage: '',
      errorUnitMessage: '',
      errorTopicMessage: '',
      title: this.$t('confirmAdd'),
    };
  },
  methods: {
    validateNameValue() {
      if (validateCString(this.inputNameValue, 2, 12)) {
        this.errorNameMessage = '';
        return true;
      }
      this.errorNameMessage = this.$t('incorrectFormat');
      return false;
    },
    validateTopicValue() {
      if (validateMqttTopic(this.inputTopicValue, 0, 32)) {
        this.errorTopicMessage = '';
        return true;
      }
      this.errorTopicMessage = this.$t('incorrectFormat');
      return false;
    },
    validateUnitValue() {
      if (validateUnitString(this.inputUnitValue, 0, 6)) {
        this.errorUnitMessage = '';
        return true;
      }
      this.errorUnitMessage = this.$t('incorrectFormat');
      return false;
    },
    validateFormatValue() {
      if (validateNumber(this.formatId, 1, 2)) {
        return true;
      }
      return false;
    },
    validateAllInputfield() {
      let check = 0;
      if (this.type !== 0) {
        this.title = this.$t('confirmSave');
      }
      if (!this.validateNameValue()) {
        check += 1;
      }
      if (!this.validateTopicValue()) {
        check += 1;
      }
      if (!this.validateUnitValue()) {
        check += 1;
      }
      if (!this.validateFormatValue()) {
        check += 1;
      }
      return check;
    },
    addsave() {
      if (this.validateAllInputfield() > 0) {
        Swal.fire({
          title: this.$t('checkFormatError'),
          icon: 'error',
        });
        return;
      }
      Swal.fire({
        icon: 'warning',
        title: this.title,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          if (this.type === 1) {
            const data = JSON.stringify({
              id: this.id,
              name: this.inputNameValue,
              format: this.formatId,
              topic: this.inputTopicValue,
              unit: this.inputUnitValue,
            });
            updateData(this.t, `${this.apiBaseUrl}/edit/${this.page}`, data, this.$router, '/data');
          } else {
            const data = JSON.stringify({
              name: this.inputNameValue,
              format: this.formatId,
              topic: this.inputTopicValue,
              unit: this.inputUnitValue,
            });
            insertData(this.t, `${this.apiBaseUrl}/new/${this.page}`, data, this.$router, '/data');
          }
        }
      });
    },
  },
};
</script>
